/**
 * Bağlantı durumu store — online / reconnecting / offline.
 *
 * EventTarget tabanlı (Lit context yerine — ek bağımlılık yok).
 * fp-connection-banner ve diğer dayanıklılık component'leri 'change' dinler.
 *
 * Memory: decision_pwa_resilience.md §1
 */
export type ConnState = 'online' | 'reconnecting' | 'offline';

class ConnectionStateStore extends EventTarget {
    private _state: ConnState = 'offline';
    private _lastOnlineMs: number = Date.now();
    private _reconnectEpoch = 0;

    get state(): ConnState {
        return this._state;
    }

    /**
     * Bağlantının son CANLI olduğu an (ms epoch) — banner "X sn önce kesildi" sayacı için.
     * Online'a girerken VE online'dan ayrılırken (kesilme anı) güncellenir. Böylece bağlantı
     * koptuğunda sayaç, "online'a girilen an"dan değil, KESİLME anından (~0) saymaya başlar.
     */
    get lastOnlineMs(): number {
        return this._lastOnlineMs;
    }

    /**
     * Her (yeniden) bağlanışta artan sayaç. Hücreler bunu izleyip reconnect sonrası
     * İLK tick'te sahte yön oku/flash'ı bastırır (prevBid kopma anındaki eski değer) (O5).
     */
    get reconnectEpoch(): number {
        return this._reconnectEpoch;
    }

    set(next: ConnState): void {
        if (this._state === next) return;
        const wasOnline = this._state === 'online';
        this._state = next;
        if (next === 'online') {
            this._lastOnlineMs = Date.now();
            if (!wasOnline) this._reconnectEpoch++;
        } else if (wasOnline) {
            // Online'dan ayrıldık (bağlantı koptu) → "son canlı" an = şimdi. Banner sayacı
            // buradan (kesilme anından) saysın; online'a girilen eski an'dan DEĞİL.
            this._lastOnlineMs = Date.now();
        }
        this.dispatchEvent(new CustomEvent('change', { detail: next }));
    }
}

export const connectionState = new ConnectionStateStore();
